// הקובץ נשאר זהה לקובץ הקודם שסופק, מכיוון שבוצעו שינויים רק ב-CSS.
import React, { useEffect, useRef, useState, useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ScrollReveal from "scrollreveal";
import styles from './SecondScreen.module.css';

// ייבוא תמונות וסרטוני גמלים וויטרינות
import gamalVit1 from "../imagesSecondScreen/גמלים וויטרינות 1.webp";
import gamalVit2 from "../imagesSecondScreen/גמלים וויטרינות 2.webp";
import gamalVit3 from "../imagesSecondScreen/גמלים וויטרינות 3.webp";
import gamalVit4 from "../imagesSecondScreen/גמלים וויטרינות 4.webm";
import gamalVit5 from "../imagesSecondScreen/גמלים וויטרינות 5.webp";
import gamalVit6 from "../imagesSecondScreen/גמלים וויטרינות 6.webp";
import gamalVit7 from "../imagesSecondScreen/גמלים וויטרינות 7.webp";
import gamalVit8 from "../imagesSecondScreen/גמלים וויטרינות 8.webm";
import gamalVit9 from "../imagesSecondScreen/גמלים וויטרינות 9.webp";
import gamalVit10 from "../imagesSecondScreen/גמלים וויטרינות 10.webm";
import gamalVit11 from "../imagesSecondScreen/גמלים וויטרינות 11.webp";
import gamalVit12 from "../imagesSecondScreen/גמלים וויטרינות 12.webm";
import gamalVit13 from "../imagesSecondScreen/גמלים וויטרינות 13.webp";

// ייבוא תמונות עוגיות
import cookies1 from "../images/עוגיות לחינה 1.webp";
import cookies2 from "../images/עוגיות לחינה 2.webp";
import cookies3 from "../images/עוגיות לחינה 3.webp";
import cookies4 from "../images/עוגיות לחינה 4.webp";
import cookies5 from "../images/עוגיות לחינה 5.webp";
import cookies6 from "../images/עוגיות לחינה 6.webp";
import cookies7 from "../images/עוגיות לחינה 7.webp";
import cookies8 from "../images/עוגיות לחינה 8.webp";
import cookies9 from "../images/עוגיות לחינה 9.webp";
import cookies10 from "../images/עוגיות לחינה 10.webp";
import cookies11 from "../images/עוגיות לחינה 11.webp";

// ייבוא תמונות תפאורה
import decor1 from "../images/תפאורה לחינה 1.webp";
import decor2 from "../images/תפאורה לחינה 2.webp";
import decor3 from "../images/תפאורה לחינה 3.webp";
import decor4 from "../images/תפאורה לחינה 4.webp";
import decor5 from "../images/תפאורה לחינה 5.webp";
import decor6 from "../images/תפאורה לחינה 6.webp";
import decor7 from "../images/תפאורה לחינה 7.webp";
import decor8 from "../images/תפאורה לחינה 8.webp";
import decor9 from "../images/תפאורה לחינה 9.webp";
import decor10 from "../images/תפאורה לחינה 10.webp";
import decor11 from "../images/תפאורה לחינה 11.webp";
import decor12 from "../images/תפאורה לחינה 12.webp";

// ייבוא תמונות תלבושות
import dress1 from "../imagesSecondScreen/20 תלבושות 1.webp";
import dress2 from "../imagesSecondScreen/20 תלבושות 2.webp";
import dress3 from "../imagesSecondScreen/20 תלבושות 3.webp";
import dress4 from "../imagesSecondScreen/20 תלבושות 4.webp";
import dress5 from "../imagesSecondScreen/20 תלבושות 5.webp";
import dress6 from "../imagesSecondScreen/20 תלבושות 6.webp";
import dress7 from "../imagesSecondScreen/20 תלבושות 7.webp";
import dress8 from "../imagesSecondScreen/20 תלבושות 8.webp";
import dress9 from "../imagesSecondScreen/20 תלבושות 9.webp";
import dress10 from "../imagesSecondScreen/20 תלבושות 10.webp";
import dress11 from "../imagesSecondScreen/20 תלבושות 11.webp";
import dress12 from "../imagesSecondScreen/20 תלבושות 12.webp";
import dress13 from "../imagesSecondScreen/20 תלבושות 13.webp";
import dress14 from "../imagesSecondScreen/20 תלבושות 14.webp";
import dress15 from "../imagesSecondScreen/20 תלבושות 15.webp";
import dress16 from "../imagesSecondScreen/20 תלבושות 16.webp";
import dress17 from "../imagesSecondScreen/20 תלבושות 17.webp";
import dress18 from "../imagesSecondScreen/20 תלבושות 18.webp";
import dress19 from "../imagesSecondScreen/20 תלבושות 19.webp";
import dress20 from "../imagesSecondScreen/20 תלבושות 20.webp";

// ייבוא שמלות כלה
import weddingDress1 from "../images/חינת הזהב שמלות 1.webp";
import weddingDress2 from "../images/חינת הזהב שמלות 2.webp";
import weddingDress3 from "../images/חינת הזהב שמלות 3.webp";
import weddingDress4 from "../images/חינת הזהב שמלות 4.webp";
import weddingDress5 from "../images/חינת הזהב שמלות 5.webp";
import weddingDress6 from "../images/חינת הזהב שמלות 6.webp";
import weddingDress7 from "../images/חינת הזהב שמלות 7.webp";
import weddingDress8 from "../images/חינת הזהב שמלות 8.webp";
import weddingDress9 from "../images/חינת הזהב שמלות 9.webp";
import weddingDress10 from "../images/חינת הזהב שמלות 10.webp";
import weddingDress11 from "../images/חינת הזהב שמלות 11.webp";
import weddingDress12 from "../images/חינת הזהב שמלות 12.webp";
import weddingDress13 from "../images/חינת הזהב שמלות 13.webp";
import weddingDress14 from "../images/חינת הזהב שמלות 14.webp";
import weddingDress15 from "../images/חינת הזהב שמלות 15.webp";
import weddingDress16 from "../images/חינת הזהב שמלות 16.webp";
import weddingDress17 from "../images/חינת הזהב שמלות 17.webp";
import weddingDress18 from "../images/חינת הזהב שמלות 18.webp";
import weddingDress19 from "../images/חינת הזהב שמלות 19.webp";
import weddingDress20 from "../images/חינת הזהב שמלות 20.webp";
import weddingDress21 from "../images/חינת הזהב שמלות 21.webp";
import weddingDress22 from "../images/חינת הזהב שמלות 22.webp";
import weddingDress23 from "../images/חינת הזהב שמלות 23.webp";
import weddingDress24 from "../images/חינת הזהב שמלות 24.webp";
import weddingDress25 from "../images/חינת הזהב שמלות 25.webp";
import weddingDress26 from "../images/חינת הזהב שמלות 26.webp";

// ייבוא תמונות וסרטוני מבואות כניסה
import entrance1 from "../images/חינת הזהב מבואות כניסה 1.jpg";
import entrance2 from "../images/חינת הזהב מבואות כניסה 2.jpg";
import entranceVid1 from "../videos/חינת הזהב מבואות כניסה 3.mp4";
import entranceVid2 from "../videos/חינת הזהב מבואות כניסה 4.mp4";

// ייבוא עוגיות נוספים
import cookiesNew1 from "../imagesSecondScreen/עוגיות נוספים 1.mp4";
import cookiesNew2 from "../imagesSecondScreen/עוגיות נוספים 2.webp";
import cookiesNew3 from "../imagesSecondScreen/עוגיות נוספים 3.webp";
import cookiesNew4 from "../imagesSecondScreen/עוגיות נוספים 4.mp4";
import cookiesNew5 from "../imagesSecondScreen/עוגיות נוספים 5.webp";
import cookiesNew6 from "../imagesSecondScreen/עוגיות נוספים 6.webp";
import cookiesNew7 from "../imagesSecondScreen/עוגיות נוספים 7.webp";
import cookiesNew8 from "../imagesSecondScreen/עוגיות נוספים 8.webp";
import cookiesNew9 from "../imagesSecondScreen/עוגיות נוספים 9.webp";
import cookiesNew10 from "../imagesSecondScreen/עוגיות נוספים 10.webp";
import cookiesNew11 from "../imagesSecondScreen/עוגיות נוספים 11.webp";
import cookiesNew12 from "../imagesSecondScreen/עוגיות נוספים 12.mp4";
import cookiesNew13 from "../imagesSecondScreen/עוגיות נוספים 13.webp";
import cookiesNew14 from "../imagesSecondScreen/עוגיות נוספים 14.mp4";
import cookiesNew15 from "../imagesSecondScreen/עוגיות נוספים 15.mp4";
import cookiesNew16 from "../imagesSecondScreen/עוגיות נוספים 16.mp4";

// ייבוא מבואות נוספים
import entranceNew1 from "../imagesSecondScreen/מבואות נוספים 1.mp4";
import entranceNew2 from "../imagesSecondScreen/מבואות נוספים 2.mp4";
import entranceNew3 from "../imagesSecondScreen/מבואות נוספים 3.webp";
import entranceNew4 from "../imagesSecondScreen/מבואות נוספים 4.webp";
import entranceNew5 from "../imagesSecondScreen/מבואות נוספים 5.webp";
import entranceNew6 from "../imagesSecondScreen/מבואות נוספים 6.webp";
import entranceNew7 from "../imagesSecondScreen/מבואות נוספים 7.webp";
import entranceNew8 from "../imagesSecondScreen/מבואות נוספים 8.webp";
import entranceNew9 from "../imagesSecondScreen/מבואות נוספים 9.webp";
import entranceNew10 from "../imagesSecondScreen/מבואות נוספים 10.webp";

// ייבוא סרטוני הנחיית טקס
import ceremony1 from "../imagesSecondScreen/הנחיית טקס 1.mp4";
import ceremony2 from "../imagesSecondScreen/הנחיית טקס 2.mp4";
import ceremony3 from "../imagesSecondScreen/הנחיית טקס 3.mp4";
import ceremony4 from "../imagesSecondScreen/הנחיית טקס 4.mp4";
import ceremony5 from "../imagesSecondScreen/הנחיית טקס 5.mp4";
import ceremony6 from "../imagesSecondScreen/הנחיית טקס 6.mp4";
import ceremony7 from "../imagesSecondScreen/הנחיית טקס 7.mp4";
import ceremony8 from "../imagesSecondScreen/הנחיית טקס 8.mp4";
import ceremony9 from "../imagesSecondScreen/הנחיית טקס 9.mp4";
import ceremony10 from "../imagesSecondScreen/הנחיית טקס 10.mp4";

gsap.registerPlugin(ScrollTrigger);

// פונקציית עזר לזיהוי קבצי וידאו
const isVideoFile = (src) => {
  if (typeof src !== 'string') return false;
  return /\.(mov|mp4|webm|ogg)/i.test(src);
};

// פונקציית עזר לזיהוי YouTube ID
const isYoutubeId = (src) => {
  if (typeof src !== 'string') return false;
  return /^[a-zA-Z0-9_-]{11}$/.test(src);
};

// שורטים של הנחיית טקס
const ceremonyShorts = [
  'QYNUSaJ2pkU',
  'Tj0qeKump24',
  '9v_k5Ibj9rE',
  'zJOwJZox440'
];

// מערכי תמונות לכל קטגוריה
const categoryImages = {
  "תפאורה מרהיבה": [decor1, decor2, decor3, decor4, decor5, decor6, decor7, decor8, decor9, decor10, decor11, decor12],
  "תלבושות חינה מהודרות": [dress1, dress2, dress3, dress4, dress5, dress6, dress7, dress8, dress9, dress10, dress11, dress12, dress13, dress14, dress15, dress16, dress17, dress18, dress19, dress20],
  "שמלות כלה מיוחדות": [
    weddingDress1, weddingDress2, weddingDress3, weddingDress4, weddingDress5, 
    weddingDress6, weddingDress7, weddingDress8, weddingDress9, weddingDress10,
    weddingDress11, weddingDress12, weddingDress13, weddingDress14, weddingDress15,
    weddingDress16, weddingDress17, weddingDress18, weddingDress19, weddingDress20,
    weddingDress21, weddingDress22, weddingDress23, weddingDress24, weddingDress25, weddingDress26
  ],
  "הנחיית טקס מקצועית": [...ceremonyShorts, ceremony1, ceremony2, ceremony3, ceremony4, ceremony5, ceremony6, ceremony7, ceremony8, ceremony9, ceremony10],
  "מבואות וילונות ועיצובים": [entrance1, entrance2, entranceVid1, entranceVid2, 'GD0zwujazs0', entranceNew1, entranceNew2, entranceNew3, entranceNew4, entranceNew5, entranceNew6, entranceNew7, entranceNew8, entranceNew9, entranceNew10],
  "עוגיות מרוקאיות": [cookies1, cookies2, cookies3, cookies4, cookies5, cookies6, cookies7, cookies8, cookies9, cookies10, cookies11, cookiesNew1, cookiesNew2, cookiesNew3, cookiesNew4, cookiesNew5, cookiesNew6, cookiesNew7, cookiesNew8, cookiesNew9, cookiesNew10, cookiesNew11, cookiesNew12, cookiesNew13, cookiesNew14, cookiesNew15, cookiesNew16],
  "שוק פיצוחים": [cookies1, cookies2, cookies3, cookies4, cookies5, cookies6, cookies7, cookies8, cookies9, cookies10, cookies11],
  "מופלטות וספינג": [cookies1, cookies2, cookies3, cookies4, cookies5, cookies6, cookies7, cookies8, cookies9, cookies10, cookies11],
  "גמלים וויטרינות מעוצבות": [gamalVit1, gamalVit2, gamalVit3, gamalVit4, gamalVit5, gamalVit6, gamalVit7, gamalVit8, gamalVit9, gamalVit10, gamalVit11, gamalVit12, gamalVit13]
};

// סימון אילו קטגוריות הן שורטים
const isYoutubeCategory = {
};

const features = [
    { 
      title: "תפאורה מרהיבה", 
      text: "תפאורה עשירה ומרהיבה - עיצוב שהופך את האולם לארמון מרוקאי",
      image: decor1
    },
    { 
      title: "תלבושות חינה מהודרות", 
      text: "תלבושות מהודרות ומעוצבות לחינה - לכלה, לחתן, להורים ולכל האורחים",
      image: dress1
    },
    { 
      title: "שמלות כלה מיוחדות", 
      text: "שמלות כלה מרהיבות ומעוצבות - מראה נסיכותי לערב המיוחד",
      image: weddingDress1
    },
    { 
      title: "הנחיית טקס מקצועית", 
      text: "הנחיית טקס מקצועית - אני מנחה את הערב ודואגת שהכל יזרום חלק",
      image: decor3
    },
    { 
      title: "מבואות וילונות ועיצובים",
      text: "מבואות מרהיבות, וילונות מעוצבים ועיצובים ייחודיים - כניסה מרשימה שקובעת את הטון לכל הערב",
      image: entrance1
    },
    { 
      title: "עוגיות מרוקאיות", 
      text: "עוגיות מרוקאיות טריות ומושקעות - טעם אותנטי שמזכיר את הבית",
      image: cookies1
    },
    { 
      title: "שוק פיצוחים", 
      text: 'מבחר פיצוחים מיוחד - "שוק פיצוחים" מלא באווירה ובצבעים',
      image: cookies5
    },
    // {
    //   title: "מופלטות וספינג",
    //   text: "מופלטות וספינג מעוצבים - פינוקים מתוקים שמוסיפים קסם לאירוע",
    //   image: cookies9
    // },
    {
      title: "גמלים וויטרינות מעוצבות",
      text: "בובת גמל וויטרינות מרהיבות - רגעים בלתי נשכחים ותצוגה מושקעת",
      image: gamalVit1
    }
];

// קומפוננטת הגלריה באוברליי - תומכת גם בתמונות וגם בשורטים
const GalleryOverlay = ({ isOpen, onClose, category, images, isYoutube }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const overlayRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setCurrentIndex(0);
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
      if (e.key === 'ArrowLeft') setCurrentIndex(prev => (prev + 1) % images.length);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, images.length, onClose]);

  const handlePrev = () => setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  const handleNext = () => setCurrentIndex(prev => (prev + 1) % images.length);

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) onClose();
  };

  if (!isOpen || !images || images.length === 0) return null;

  return (
    <div ref={overlayRef} className={styles.galleryOverlay} onClick={handleOverlayClick}>
      <button className={styles.closeButton} onClick={onClose}>✕</button>
      
      <div className={styles.galleryContent}>
        <button className={styles.navButton} onClick={handlePrev}>❮</button>
        
        <div className={(isYoutube || isYoutubeId(images[currentIndex])) ? styles.youtubeContainer : styles.imageContainer}>
          {(isYoutube || isYoutubeId(images[currentIndex])) ? (
            <iframe
              key={currentIndex}
              src={`https://www.youtube-nocookie.com/embed/${images[currentIndex]}?autoplay=1&controls=1&modestbranding=1&rel=0`}
              title={`${category} ${currentIndex + 1}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className={styles.youtubeIframe}
            />
          ) : isVideoFile(images[currentIndex]) ? (
            <video
              key={currentIndex}
              src={images[currentIndex]}
              controls
              autoPlay
              muted
              playsInline
              webkit-playsinline=""
              preload="metadata"
              className={styles.galleryImage}
            />
          ) : (
            <img
              src={images[currentIndex]}
              alt={`${category} ${currentIndex + 1}`}
              className={styles.galleryImage}
              loading="lazy"
            />
          )}
        </div>
        
        <button className={styles.navButton} onClick={handleNext}>❯</button>
      </div>

      <h3 className={styles.categoryTitle}>{category}</h3>
      
      <div className={styles.imageCounter}>
        {currentIndex + 1} / {images.length}
      </div>

      <div className={styles.thumbnailsContainer}>
        {images.map((item, index) => (
          <div
            key={index}
            className={`${styles.thumbnail} ${index === currentIndex ? styles.activeThumbnail : ''}`}
            onClick={() => setCurrentIndex(index)}
          >
            {(isYoutube || isYoutubeId(item)) ? (
              <img
                src={`https://img.youtube.com/vi/${item}/mqdefault.jpg`}
                alt={`שורט ${index + 1}`}
                loading="lazy"
              />
            ) : isVideoFile(item) ? (
              <video src={item} muted playsInline className={styles.galleryImage} />
            ) : (
              <img src={item} alt={`תמונה ${index + 1}`} loading="lazy" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// קומפוננטת כרטיס - עיצוב מקורי עם תמונת רקע מ-CSS
const FeatureCard = ({ title, text, onClick, index }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    ScrollReveal().reveal(containerRef.current, {
      duration: 1000,
      distance: "100px",
      origin: "left",
      easing: "ease-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 200,
      scale: 1,
    });
  }, []);

  return (
    <div 
      ref={containerRef}
      className={styles.container}
      onClick={onClick}
    >
      {/* תמונת רקע - class דינמי לפי אינדקס */}
      <div className={`${styles.backgroundImage} ${styles[`bg${index}`]}`} />
      {/* שכבת כיסוי כהה */}
      <div className={styles.backgroundOverlay} />
      {/* תוכן */}
      <div className={styles.content}>
        <div className={styles.glassBox}>
          <div className={styles.title}>{title}</div>
          <p className={styles.text}>{text}</p>
          <span className={styles.viewMore}>לחצו לצפייה בגלריה ←</span>
        </div>
      </div>
    </div>
  );
};

const SecondScreen = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const itemsRef = useRef([]);
  const summaryRef = useRef(null);
  const ctaRef = useRef(null);
  const connectingSvgRef = useRef(null);
  const [pathSegments, setPathSegments] = useState([]);
  const segmentsRef = useRef([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);

  const handleCardClick = (title) => {
    setSelectedCategory(title);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
    setSelectedCategory(null);
  };

  // פונקציית עזר ליצירת נתיב מעוקל
  const createCurvedPath = (x1, y1, x2, y2, isRightStart) => {
    const offset = 50;
    const cx1 = isRightStart ? x1 - offset : x1 + offset;
    const cx2 = isRightStart ? x2 - offset : x2 + offset;
    const cy1 = y1 + (y2 - y1) * 0.3; 
    const cy2 = y2 - (y2 - y1) * 0.3;
    return `M ${x1} ${y1} C ${cx1} ${cy1}, ${cx2} ${cy2}, ${x2} ${y2}`;
  };

  // פונקציה לפתיחת WhatsApp
  const openWhatsApp = () => {
    const phoneNumber = '972507277178';
    const message = 'היי חינת הזהב, אשמח לקבל עוד פרטים לגבי האירוע שלי';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  // useLayoutEffect לחישוב מיקומי ה-SVG
  useLayoutEffect(() => {
    const calculatePaths = () => {
      if (!sectionRef.current) return;

      const pathContainer = sectionRef.current.querySelector(`.${styles.pathContainer}`);
      const svgEl = connectingSvgRef.current;
      
      if (itemsRef.current.filter(Boolean).length !== features.length) {
        return;
      }
      
      if (svgEl && pathContainer) {
          svgEl.style.height = `${pathContainer.offsetHeight}px`;
          svgEl.setAttribute('viewBox', `0 0 800 ${pathContainer.offsetHeight}`);
      }

      const newSegments = [];
      if (!svgEl) return;

      itemsRef.current.forEach((item, index) => {
        if (item && itemsRef.current[index + 1]) {
          const nextItem = itemsRef.current[index + 1];
          const itemRect = item.getBoundingClientRect();
          const nextRect = nextItem.getBoundingClientRect();

          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          const currentIsRight = item.classList.contains(styles.featureRight);
          const currentCenterX = currentIsRight ? 700 : 100;
          
          const svgTop = pathContainer.getBoundingClientRect().top + scrollTop;
          const currentCenterY = (itemRect.top + itemRect.bottom) / 2 + scrollTop - svgTop;

          const nextIsRight = nextItem.classList.contains(styles.featureRight);
          const nextCenterX = nextIsRight ? 700 : 100;
          const nextCenterY = (nextRect.top + nextRect.bottom) / 2 + scrollTop - svgTop;
          
          const d = createCurvedPath(currentCenterX, currentCenterY, nextCenterX, nextCenterY, currentIsRight);

          newSegments.push({ id: index, d });
        }
      });

      setPathSegments(newSegments);
    };

    const initialTimer = setTimeout(calculatePaths, 100);
    const loadTimer = setTimeout(calculatePaths, 500);
    
    const handleResize = () => {
      calculatePaths();
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('load', calculatePaths);
    
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(loadTimer);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('load', calculatePaths);
    };
  }, [features.length]);

  // useEffect לאנימציות GSAP
  useEffect(() => {
    if (pathSegments.length === 0) return;

    const ctx = gsap.context(() => {
      
      gsap.fromTo(
        titleRef.current,
        { opacity: 0, y: 80, scale: 0.9 },
        {
          scrollTrigger: { trigger: sectionRef.current, start: "top 75%", end: "top 40%", scrub: 1 },
          opacity: 1, y: 0, scale: 1, ease: "power2.out"
        }
      );

      itemsRef.current.forEach((item, index) => {
        if (!item) return;

        gsap.fromTo(
          item,
          { opacity: 0, x: index % 2 === 0 ? -100 : 100, scale: 0.7 },
          {
            scrollTrigger: { trigger: item, start: "top 90%", end: "top 60%", scrub: 1 },
            opacity: 1, x: 0, scale: 1, ease: "power3.out",
          }
        );

        item.addEventListener('mouseenter', () => gsap.to(item, { scale: 1.03, y: -8, duration: 0.4, ease: "power2.out" }));
        item.addEventListener('mouseleave', () => gsap.to(item, { scale: 1, y: 0, duration: 0.4, ease: "power2.out" }));
      });
      
      segmentsRef.current.forEach((path, index) => {
        if (!path) return;
        const length = path.getTotalLength();
        gsap.set(path, { strokeDasharray: length, strokeDashoffset: length });

        const currentItem = itemsRef.current[index];
        const nextItem = itemsRef.current[index + 1];

        if (currentItem && nextItem) {
          gsap.to(path, {
            strokeDashoffset: 0,
            ease: "none",
            scrollTrigger: {
              trigger: currentItem,
              start: "top center", 
              endTrigger: nextItem,
              end: "top center", 
              scrub: 0.5,
              invalidateOnRefresh: true,
            }
          });
        }
      });
      
      gsap.fromTo(summaryRef.current, { opacity: 0, y: 60 }, { scrollTrigger: { trigger: summaryRef.current, start: "top 85%", end: "top 60%", scrub: 1 }, opacity: 1, y: 0, ease: "power2.out" });
      gsap.fromTo(ctaRef.current, { opacity: 0, scale: 0.8, y: 40 }, { scrollTrigger: { trigger: ctaRef.current, start: "top 90%", end: "top 70%", scrub: 1 }, opacity: 1, scale: 1, y: 0, ease: "back.out(1.7)" });

    }, sectionRef);

    return () => ctx.revert();
  }, [pathSegments]);

  return (
    <div ref={sectionRef} className={styles.secondScreen} id="מה תקבלי בחינה">
      <div className={styles.mainContainer}>
        <h2 ref={titleRef} className={styles.mainTitle}>
         מה תוכלו למצוא <span className={styles.goldText}>בחינת הזהב?</span>
        </h2>

        <div className={styles.pathContainer}>
          <svg ref={connectingSvgRef} className={styles.connectingSvg} preserveAspectRatio="xMidYMid meet">
            <defs>
              <linearGradient id="pathGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#c9a876" stopOpacity="0.8"/>
                <stop offset="100%" stopColor="#e8dcc8" stopOpacity="0.8"/>
              </linearGradient>
            </defs>
            
            {pathSegments.map((segment, index) => (
              <path
                key={segment.id}
                ref={el => segmentsRef.current[index] = el}
                className={styles.pathSegment}
                d={segment.d}
                stroke="url(#pathGradient)"
                strokeWidth="4"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            ))}
          </svg>

          <div className={styles.featuresPath}>
            {features.map((feature, index) => (
              <div
                key={index}
                ref={(el) => itemsRef.current[index] = el}
                className={`${styles.featureItem} ${index % 2 === 0 ? styles.featureRight : styles.featureLeft}`}
              >
                <FeatureCard 
                  title={feature.title}
                  text={feature.text} 
                  index={index}
                  onClick={() => handleCardClick(feature.title)}
                />
              </div>
            ))}
          </div>
        </div>
  
        <div ref={summaryRef} className={styles.summarySection}>
          <p className={styles.summaryText}>
            זה לא רק שירות של תלבושות או עוגיות, אלא <span className={styles.highlight}>חבילת חינה מלאה</span> שמטפלת בכל פרט, מהעיצוב ועד ההנחיה על הבמה עם נסיון של 18 שנה בתחום וליווי אישי מקצה לקצה!
          </p>
        </div>
        
        <button ref={ctaRef} className={styles.ctaButton} onClick={openWhatsApp}>
          לחצי כאן ואנחנו מדברות על האירוע שלך
        </button>
      </div>

      {/* גלריית תמונות */}
      <GalleryOverlay 
        isOpen={isGalleryOpen} 
        onClose={closeGallery}
        category={selectedCategory}
        images={selectedCategory ? categoryImages[selectedCategory] : []}
        isYoutube={selectedCategory ? isYoutubeCategory[selectedCategory] : false}
      />
    </div>
  );
};

export default SecondScreen;